import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitValuation = (payload) =>
  axios.post(`${API}/valuation`, payload).then((r) => r.data);

export const submitContact = (payload) =>
  axios.post(`${API}/contact`, payload).then((r) => r.data);

export const fetchLeads = () => axios.get(`${API}/leads`).then((r) => r.data);
